import {TaxSettings} from "./tax-settings";
import {Utils} from "../../../../../../shared/utils/utils";

export class TaxSettingsMapper {
  public static map(data: any): TaxSettings {
    let taxSettings: TaxSettings = new TaxSettings();
    taxSettings.id = data.id;
    taxSettings.description = data.description;
    taxSettings.value = data.value;
    taxSettings.options = Utils.makeOptionsReadable(data.options);
    taxSettings.default = data.default;
    taxSettings.tip = data.tip;
    taxSettings.label = data.label;
    return taxSettings;
  }

}
